import { RELATED_PARTY_RELATIONSHIP } from '../../../../../../../constants';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Rule } from '../../interfaces/Rule';

class RelatedPartyRelationshipEqualsTo implements Rule {
  private principalId: any;
  private relationship: RELATED_PARTY_RELATIONSHIP;

  public setPrincipalId(id: any) {
    this.principalId = id;
    return this;
  }

  public setRelationship(relationship: RELATED_PARTY_RELATIONSHIP) {
    this.relationship = relationship;
    return this;
  }

  private getPrincipal(data: Partial<ApplicationFormValues>) {
    return data.principals?.find(
      (principal) => principal.id === this.principalId
    );
  }

  public evaluate(application: Partial<ApplicationFormValues>): boolean {
    const relatedParty = this.getPrincipal(application);
    const isSameRelationship =
      relatedParty?.relationship == (this.relationship as unknown as string);

    return isSameRelationship ?? false;
  }
}

export default new RelatedPartyRelationshipEqualsTo();
